import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text, Pressable, View } from 'react-native';

import Hr from 'LocalGluons/components/Hr';
import Icon from 'LocalGluons/components/Icon';
import sectionListStyles from '../../SectionList.jss';

const SectionListItem = ({ title, onPress, testID }) => (
    <View style={sectionListStyles.outerItemContainer} testID={testID}>
        {onPress ? (
            <>
                <Pressable style={sectionListStyles.innerItemContainer} onPress={onPress}>
                    <>
                        <Text style={sectionListStyles.itemName}>{title}</Text>
                        <Icon style={sectionListStyles.openIcon} name="arrow_right" />
                    </>
                </Pressable>
                <Hr />
            </>
        ) : (
            <>
                <Text style={sectionListStyles.itemName}>{title}</Text>
                <Hr />
            </>
        )}
    </View>
);

SectionListItem.defaultProps = {
    onPress: null,
    testID: undefined
};

SectionListItem.propTypes = {
    title: PropTypes.string.isRequired,
    onPress: PropTypes.func,
    testID: PropTypes.string
};

export default SectionListItem;
